export default __webpack_public_path__ + "static/media/iconArrowLeft2.4aa6e9d8.svg";